import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DownloadFormat } from '../../downloads/downloads.service';

@Component({
  selector: 'app-download-format-matrix',
  templateUrl: './download-format-matrix.component.html',
  styleUrls: ['./download-format-matrix.component.scss'],
  standalone: false,
})
export class DownloadFormatMatrixComponent {
  @Input() formats: DownloadFormat[] = [];
  @Input() selectedFormat?: DownloadFormat['value'];
  @Output() onFormatSelect = new EventEmitter<DownloadFormat['value']>();
  showDetailedComparison = false;

  // for the matrix table
  featureCategories = [
    {
      name: 'Data Coverage',
      features: [
        { name: 'Best For', key: 'bestFor' },
        { name: 'Person Data', key: 'personData' },
        { name: 'Job History', key: 'jobHistory' },
        { name: 'Job Details', key: 'jobDetails' },
        { name: 'Company Data', key: 'companyData' },
        { name: 'Education Data', key: 'educationData' },
      ],
    },
    {
      name: 'Format Details',
      features: [
        { name: 'File Format', key: 'fileFormat' },
        { name: 'Field/Column Count', key: 'columnCount' },
        { name: 'Excel Compatible', key: 'excelCompatible' },
      ],
    },
    {
      name: 'Technical Considerations',
      features: [{ name: 'Machine Readable', key: 'machineReadable' }],
    },
  ];

  getFeatureValue(format: DownloadFormat, featureKey: string): string {
    const feature = format.featureDescriptions.find((f) => f.key === featureKey);
    return feature?.description || '';
  }

  getFeatureIndicator(format: DownloadFormat, featureKey: string): string {
    const feature = format.featureDescriptions.find((f) => f.key === featureKey);
    return feature?.indicator || 'none';
  }

  selectFormat(format: DownloadFormat['value']) {
    this.onFormatSelect.emit(format);
  }
}
